import React, { useState } from "react";
import { Form } from "react-bootstrap";

const compilerVersions = [
  "Please Select",
  "v0.4.0",
  "v0.3.10",
  "v0.3.9",
  "v0.3.8",
];

const VyperCompiler = () => {
  const [compilerVersion, setCompilerVersion] = useState("");
  const [sourceCode, setSourceCode] = useState("");

  const handleReset = () => {
    setCompilerVersion("");
    setSourceCode("");
  };

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-lg-12">
          <div className="bs-page-title">
            Vyper Online Compiler (Experimental)
          </div>
        </div>
        <div className="pb-3">
          <div className="text-muted">
            Compiles Vyper source code and outputs the ABI, Bytecode and Runtime
            Bytecode.
          </div>
        </div>
      </div>

      <div className="bs-card p-3">
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Select Compiler Version</Form.Label>
            <Form.Select
              value={compilerVersion}
              onChange={(event) => setCompilerVersion(event.target.value)}
            >
              {compilerVersions.map((version) => (
                <option
                  key={version}
                  value={version === "Please Select" ? "" : version}
                >
                  {version}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Enter Source Code</Form.Label>
            <Form.Control
              as="textarea"
              rows={10}
              className="font-monospace"
              placeholder="Please enter Source Code"
              value={sourceCode}
              onChange={(event) => setSourceCode(event.target.value)}
              style={{ minHeight: "220px", resize: "vertical" }}
            />
          </Form.Group>

          <div className="d-flex flex-column flex-md-row gap-2">
            <button
              type="button"
              className="btn btn-outline-secondary w-100"
              onClick={handleReset}
            >
              Reset
            </button>
            <button type="button" className="btn btn-primary w-100" disabled>
              Compile Vyper
            </button>
          </div>

          <div className="text-muted small mt-3">
            Tip: Try compiling the sample{" "}
            <a
              href="https://raw.githubusercontent.com/prysmaticlabs/prysm/62f304e668bc78c4078cd376ba141b58eea777ef/contracts/deposit-contract/depositContract.v.py"
              target="_blank"
              rel="noreferrer"
            >
              Prysmaticlabs Contract
            </a>{" "}
            (for Vyper version 0.1.0b7)
          </div>
        </Form>
      </div>
    </React.Fragment>
  );
};

export default VyperCompiler;
